export default function NoteIcon() {
  return (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.91732 22.1667H9.33398C4.66732 22.1667 2.33398 21 2.33398 15.1667V9.33337C2.33398 4.66671 4.66732 2.33337 9.33398 2.33337H18.6673C23.334 2.33337 25.6673 4.66671 25.6673 9.33337V15.1667C25.6673 19.8334 23.334 22.1667 18.6673 22.1667H18.084C17.7223 22.1667 17.3723 22.3417 17.1507 22.6334L15.4007 24.9667C14.6307 25.9934 13.3707 25.9934 12.6007 24.9667L10.8507 22.6334C10.664 22.3767 10.2323 22.1667 9.91732 22.1667Z"
        stroke="#1E2E5E"
        strokeWidth="2.25"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.6619 12.8333H18.6724"
        stroke="#1E2E5E"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.9949 12.8333H14.0054"
        stroke="#1E2E5E"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M9.32693 12.8333H9.3374" stroke="#1E2E5E" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
